module.exports = __webpack_public_path__ + "catalog/items/bedroom/bedside-table/bedside-table.svg";